import { render } from "./AlternativeHeader.vue?vue&type=template&id=1b4320e2&scoped=true"
import script from "./AlternativeHeader.vue?vue&type=script&lang=js"
export * from "./AlternativeHeader.vue?vue&type=script&lang=js"

import "./AlternativeHeader.vue?vue&type=style&index=0&id=1b4320e2&lang=css"
import "./AlternativeHeader.vue?vue&type=style&index=1&id=1b4320e2&scoped=true&lang=css"

import exportComponent from "/home/armin/w/euro-petrol-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b4320e2"]])

export default __exports__